import { EChartsOption } from "echarts";
export interface Props {
  value: number;
  max: number;
  min: number;
  position?: "left" | "right";
}

export const getDefaultChartOptions = (props: Props) => {
  let backgroundColor = "rgba(0,0,0,.0)";
  let chartdata = [
    {
      value: props.value,
    },
  ];
  let max = props.max;
  let color = "#00ff00";
  if (props.value >= max * 0.66) {
    // 33
    color = "#ff0000";
  } else if (props.value >= max * 0.33) {
    // 16.5
    color = "#ffeb3b";
  } else {
    color = "#00ff00";
  }

  let barWidth = 20;
  const offset = props.value.toString().length * 5;

  const labelPosition =
    props.position === "right" ? [barWidth, -5] : [-barWidth - offset, -5];
  const option = {
    animation: false,
    animationDuration: 1000,
    backgroundColor: backgroundColor,
    grid: {
      top: "10",
      right: "0",
      left: "30",
      bottom: "10", //图表尺寸大小
    },
    yAxis: {
      show: true,
      max: max,
      name: "xxx",
      axisLine: {
        show: false, //坐标线
      },
      axisTick: {
        show: false, //小横线
      },
      axisLabel: {
        show: false,
        color: "#fff", //坐标轴字颜色
      },
      splitLine: {
        show: false,
      },
    },
    xAxis: {
      show: false,
      type: "category",
      data: [1, 2, 3],
      axisLine: {
        show: false, //坐标线
      },
      axisTick: {
        show: false, //小横线
      },
      axisLabel: {
        show: false,
        color: "#fff", //坐标轴字颜色
      },
    },

    series: [
      {
        type: "bar",
        name: 1,
        barWidth: barWidth,
        showBackground: true,
        backgroundStyle: {
          color: "rgba(220, 220, 220, 0.4)",
          // barBorderRadius: [30, 30, 30, 30] //圆角大小
        },
        label: {
          show: true,
          position: labelPosition, //每一条的数据位置
          formatter: (params) => {
            if (props.position === "right") {
              return "◀" + params.value;
            } else {
              return params.value + "▶";
            }
          },
          color: "#fff",
          fontSize: 16,
          // rotate: 90,
        },
        itemStyle: {
          color: "rgba(0,0,0,.0)", //每个数据的颜色
          // barBorderRadius: [30, 30, 30, 30], //圆角大小
          shadowBlur: 10,
          shadowColor: "rgba(0, 103, 255, 0.2)",
          shadowOffsetX: -5,
          shadowOffsetY: 5,
        },
        data: chartdata,
        z: 1,
      },
      {
        type: "bar",
        name: 1,
        barGap: "-100%", // 使柱子之间没有间隔
        barWidth: barWidth,
        legendHoverLink: false,
        symbolRepeat: true,
        silent: true,
        itemStyle: {
          // color: color,
          color:  {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color:color , // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#00ff00", // 100% 处的颜色
              },
            ],
          },
          shadowBlur: 4,
          shadowColor: "#74ddff",
        },
        data: [{ value: props.value }],
        z: 1,
      },
      {
        type: "pictorialBar",
        barGap: -200, // 使柱子之间没有间隔
        itemStyle: {
          color: "#000",
        },
        symbolRepeat: "fixed",
        symbolMargin: 4,
        symbol: "Rect",
        symbolClip: true,
        symbolSize: [barWidth, 2],
        symbolPosition: "start",
        symbolOffset: [0, 0],
        data: [{ value: 100 }],
        z: 2,
      },
    ],
  } as EChartsOption;
  return option;
};

// export const getDefaultChartOptions = () => {
//   let barWidth = "80%";
//   var data1 = [100];
//   var titlename = ["时间"];
//   var valdata = [100];
//   const option = {
//     backgroundColor: "rgba(0,0,0,.0)",
//     grid: {
//       top: 30,
//       left: 30,
//       right: 30,
//       bottom: 30,
//     },
//     xAxis: {
//       show: true,
//       inverse: false,
//       axisLine: {
//         show: false,
//       },
//       splitLine: {
//         show: false,
//       },
//       axisTick: {
//         show: false,
//       },
//     },
//     yAxis: [
//       {
//         show: false,
//         data: titlename,
//         inverse: false,
//         axisLine: {
//           show: true,
//         },
//         splitLine: {
//           show: false,
//         },
//         axisTick: {
//           show: false,
//         },
//       },
//       {
//         show: false,
//         inverse: false,
//         data: titlename,
//         axisLabel: {
//           textStyle: {
//             fontSize: 12,
//             color: "#fff",
//           },
//         },
//         axisLine: {
//           show: false,
//         },
//         splitLine: {
//           show: false,
//         },
//         axisTick: {
//           show: false,
//         },
//       },
//     ],
//     series: [
//       //内
//       {
//         type: "bar",
//         barWidth: barWidth,
//         legendHoverLink: false,
//         symbolRepeat: true,
//         silent: true,
//         itemStyle: {
//           color: {
//             type: "linear",
//             x: 0,
//             y: 0,
//             x2: 1,
//             y2: 0,
//             colorStops: [
//               {
//                 offset: 0,
//                 color: "#ff0000", // 0% 处的颜色
//               },

//               {
//                 offset: 1,
//                 color: "#00ff00", // 100% 处的颜色
//               },
//             ],
//           },
//           shadowBlur: 4,
//           shadowColor: "#74ddff",
//         },
//         data: data1,
//         z: 1,
//         animationEasing: "elasticOut",
//       },
//       // 背景
//       // {
//       //   type: "pictorialBar",
//       //   animationDuration: 0,
//       //   symbolRepeat: "fixed",
//       //   symbolMargin: "20%",
//       //   symbol: "roundRect",
//       //   symbolSize: [6, barWidth],
//       //   itemStyle: {
//       //     normal: {
//       //       color: "#12272A",
//       //     },
//       //   },
//       //   label: {
//       //     show: false,
//       //   },
//       //   data: data1,
//       //   z: 0,
//       //   animationEasing: "elasticOut",
//       // },
//       //分隔
//       {
//         type: "pictorialBar",
//         itemStyle: {
//           color: "#fff",
//         },
//         symbolRepeat: "fixed",
//         symbolMargin: 4,
//         symbol: "Rect",
//         symbolClip: true,
//         symbolSize: [2, "100%"],
//         symbolPosition: "start",
//         symbolOffset: [0, 0],
//         data: data1,
//         z: 2,
//         animationEasing: "elasticOut",
//       },
//       // 图标
//       // {
//       //   name: "图标",
//       //   type: "pictorialBar",
//       //   symbol:
//       //     "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAZlBMVEUAAABe3uVe3+Vf3uVf3+Zf3uVg3+Zg3+Zf3+Vi4OZh4OZg3+Z86/Bh3+Zi4Odj4Odi4OZ86/B76/B86/Bj4ed56+9x5+xn4umB7/N87PB36e+A7/N+7fF/7vJ/7vJ+7fGA7/OB7/PReX+lAAAAIXRSTlMABQkVDREmIhk3MR10LEFFPHh7cUprXE35h2XnqMLAp+mHAG9cAAAB5ElEQVRIx83WjU7CMBQFYIoiKMqU/XUboHv/l/Tce7t2XamDNSacETEmX86tlK2rx4py150o+MstMBLwWRfHKo6JCVxLnvmFGBjFQ58oF1//sUZhGy/ClSTWObgnL4O+bkeN4nY2okfNMbkRt9/vtxz8InoTsWplJSCzFxPmO8+GpSIByX3YQAuGDWtRKhKjCnxDXhF6Z4yxnZ20Wgko7BMRDmxtSGVaI4kdTIgb+zTYoJQlIMlDlmUFgrcDWWC201qSayqlTkiCddWWeV62VU0YlnpRi9VOKaSUsiyq/N0krwq2Ugt7lVpZl5BfHNiytjagMi+XYp0kCR45hMlivVQrE/uU5pXSrCB5bM6d1t2lOZItMqmliT3q5uVxqxzyW/ccfYLNKx7ZTeykMvNyac2yt2Fbc61MHLSC0rwoxbiNdlQ3GBm1NLHQsHUrtEXppR/ljNpW6DbSCoqlFiVoN6YdaFlgsSFVPs1BdT8OaB5QyQzVcaqWDows/zepxR8ObLglTrdtCRVuRNj4Rrxh+//0ke2f8KVL+Kon3GCSbmsJN9OUW3j6g0Ns+LgCij2u0h+Sghc8mlMPBMgdx5DFh59VmOVHrvmDnoNxCz3J7MFWsMuaLyR089xz/xhlfijvwutR8gv3zk6BLUUeCgAAAABJRU5ErkJggg==",
//       //   symbolSize: [50, 50],
//       //   symbolOffset: [-25, 0],
//       //   z: 12,
//       //   itemStyle: {
//       //     normal: {
//       //       color: "#14b1eb",
//       //     },
//       //   },
//       //   symbolPosition: "end",
//       //   data: data1,
//       // },
//       // 外框
//       {
//         name: "外框",
//         type: "bar",
//         barGap: "-100%", // 设置外框粗细
//         yAxisIndex: 1,
//         data: [100],
//         barWidth: "80%",
//         itemStyle: {
//           normal: {
//             color: "none",
//             borderColor: "#74ddff",
//           },
//         },
//       },
//     ],
//   } as EChartsOption;
//   return option;
// };
